import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import iconRetina from "leaflet/dist/images/marker-icon-2x.png";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl: iconRetina, iconUrl: icon, shadowUrl: iconShadow });

// Editable map: click to place, drag the pin to fine-tune the exact spot. Calls onChange({lat,lng}).
export default function MapPicker({ coords, onChange }) {
  const elRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const placeMarker = (lat, lng) => {
    const map = mapRef.current;
    if (!map) return;
    if (!markerRef.current) {
      markerRef.current = L.marker([lat, lng], { draggable: true }).addTo(map);
      markerRef.current.on("dragend", () => {
        const p = markerRef.current.getLatLng();
        onChangeRef.current && onChangeRef.current({ lat: p.lat, lng: p.lng });
      });
    } else {
      markerRef.current.setLatLng([lat, lng]);
    }
  };

  useEffect(() => {
    if (!elRef.current || mapRef.current) return;
    const center = coords ? [coords.lat, coords.lng] : [-23.55, -46.63];
    const map = L.map(elRef.current, { attributionControl: false }).setView(center, coords ? 16 : 12);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19 }).addTo(map);
    map.on("click", (e) => { placeMarker(e.latlng.lat, e.latlng.lng); onChangeRef.current && onChangeRef.current({ lat: e.latlng.lat, lng: e.latlng.lng }); });
    mapRef.current = map;
    if (coords) placeMarker(coords.lat, coords.lng);
    setTimeout(() => map.invalidateSize(), 150);
    return () => { map.remove(); mapRef.current = null; markerRef.current = null; };
  }, []); // eslint-disable-line

  useEffect(() => {
    const map = mapRef.current;
    if (!map || !coords || coords.lat == null) return;
    placeMarker(coords.lat, coords.lng);
    map.setView([coords.lat, coords.lng], Math.max(map.getZoom(), 16));
  }, [coords?.lat, coords?.lng]); // eslint-disable-line

  return <div ref={elRef} data-testid="map-picker" className="h-64 w-full rounded-sm overflow-hidden border border-white/10 z-0" />;
}
